import { render } from "./HeaderAtom.vue?vue&type=template&id=a0772e58&scoped=true"
import script from "./HeaderAtom.vue?vue&type=script&lang=js"
export * from "./HeaderAtom.vue?vue&type=script&lang=js"

import "./HeaderAtom.vue?vue&type=style&index=0&id=a0772e58&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0772e58"]])

export default __exports__